module.exports = __webpack_public_path__ + "static/img/3.4d80651.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fafafa/3.png
// module id = 9Gao
// module chunks = 0